import React from 'react';
import moment from 'moment';

export default class MaintenanceRow extends React.Component {

  renderAction(RowData, UserReducer) {
    const {isAdmin} = UserReducer.props
    let action = null
    let isOwner = UserReducer.username === RowData.CreatedBy
    
    if(RowData.Status === 'incomplete') {
      if(RowData.Service.hasOwnProperty('IsQuickTest')) {
        if(RowData.Service.IsQuickTest) {
          if(isAdmin || isOwner) {
            action = <button onClick={()=>this.props.onStartQuickTest(RowData.Alias)} className="btn btn-sm btn-primary">Quick Test</button>
          }else{
            action = <button className="btn btn-sm btn-default" disabled>Quick Test</button>
          }
        }else {
          if(isAdmin) {
            action = <button onClick={()=>this.props.onStartWork(RowData.Alias)} className="btn btn-sm btn-primary">Start Work</button>
          }else{
            action = <button className="btn btn-sm btn-default" disabled>Start Work</button>
          }
        }
      }
    } else if(RowData.Status === 'in-progress') {
      if(isAdmin) {
        action = <button onClick={()=>this.props.onFinishWork(RowData.Alias)} className="btn btn-sm btn-success">Finish Work</button>
      }else{
        action = <button className="btn btn-sm btn-default" disabled>Finish Work</button>
      }

    } else if(RowData.Status === 'completed') {
      action = <span className="badge badge-default" >Finished</span>

    } else {
      action = <span className="badge badge-default" >-</span>
    }

    return action
  }

  renderManageButton() {
    const {RowData, dataAsset} = this.props
    let manageButton
    
    if(RowData.IsReminder === 'Yes' && RowData.Status !== 'completed' && RowData.Status !== 'in-progress') {
      manageButton = <a className="manage-button apple-blue hover-apple-blue" onClick={()=>this.props.history.push('../maintenance/remainder-list/' + RowData.Alias + '/' + dataAsset.Name)} role="button">Manage Reminder</a>;
    } else {
      manageButton = <a className="manage-button disable" role="button">Manage Reminder</a>;
    }
    return manageButton
  }

  renderEditButton() {
    const {RowData, dataAsset} = this.props

    // BECAUSE from server dont response asset detail. so asset append from FRONTEND.
    let appendAsset = {
      ...RowData,
      Asset: {
        ...dataAsset
      }
    }

    let editButton;

    if(RowData.Status === 'incomplete') {
      editButton = <button onClick={()=>this.props.openModalEdit(appendAsset)} type="button" className="btn btn-4r btn-sm btn-primary"><i className="icon-pencil"></i></button>
    } else if (RowData.Status === 'in-progress') {
      editButton = <button onClick={()=>this.props.openModalEdit(appendAsset)} type="button" className="btn btn-4r btn-sm btn-primary"><i className="icon-pencil"></i></button>
    } else {
      editButton = <button type="button" className="btn btn-4r btn-sm btn-default" disabled><i className="icon-pencil"></i></button>
    }

    return editButton
  }

  render() {
    const {RowData, UserReducer} = this.props
    return (
      <tr>
				<td>
          <span>{RowData.Service.Name}</span>
          <div className="text-muted">
            <small>{`Duration: ${RowData.Service.Duration} Hours`}</small>
          </div>
        </td>
				<td>{RowData.ScheduledStart != null ? moment(RowData.ScheduledStart).format('ll') : '-'}</td>
				<td>{RowData.ScheduledEnd != null ? moment(RowData.ScheduledEnd).format('ll') : '-'}</td>
        {this.props.usedFor === 'inAdmin' && 
          <td className="text-center">
            <span>{RowData.IsReminder}</span>
            <div className="small text-muted">
              {this.renderManageButton()}
            </div>
          </td>
        }
        {this.props.usedFor === 'inAdmin' && <td className="text-center">{this.renderEditButton()}</td> }

        <td className="text-center">{this.renderAction(RowData, UserReducer)}</td>
			</tr>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App/asset/simple_asset/helper/component/Row/MaintenanceRow.js